// src/components/tabs/BoxOfficeTab.jsx
import React from 'react';

function BoxOfficeTab({ movie }) {
  if (!movie) return <div>No movie selected</div>;
  
  // Format currency
  const formatCurrency = (amount) => {
    if (!amount && amount !== 0) return 'N/A';
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      maximumFractionDigits: 0
    }).format(amount);
  };
  
  // Calculate profit/loss
  const budget = movie.budget || 0;
  const revenue = movie.revenue || 0;
  const profit = revenue - budget;
  const isProfit = profit >= 0;
  
  return (
    <div className="box-office-tab">
      <h2>Box Office Performance</h2>
      
      <div className="financial-overview">
        <div className="financial-metric">
          <h3>Budget</h3>
          <p className="budget">{formatCurrency(budget)}</p>
        </div>
        
        <div className="financial-metric">
          <h3>Revenue</h3>
          <p className="revenue">{formatCurrency(revenue)}</p>
        </div>
        
        <div className="financial-metric">
          <h3>Profit/Loss</h3>
          <p className={isProfit ? "profit" : "loss"}>
            {isProfit ? '+' : ''}{formatCurrency(profit)}
          </p>
        </div>
      </div>
      
      <div className="box-office-chart">
        <div className="chart-placeholder">
          <div className="bar budget-bar" style={{ height: `${budget > 0 ? Math.min(budget / 1000000, 200) : 10}px` }}>
            <span>Budget</span>
          </div>
          <div className="bar revenue-bar" style={{ height: `${revenue > 0 ? Math.min(revenue / 1000000, 200) : 10}px` }}>
            <span>Revenue</span>
          </div>
        </div>
      </div>
      
      <div className="box-office-note">
        <p>Note: Financial information may not be complete or accurate.</p>
      </div>
    </div>
  );
}

export default BoxOfficeTab;